// eslint-disable-next-line import/no-extraneous-dependencies
import "whatwg-fetch";
import { NativeEventSource, EventSourcePolyfill } from "event-source-polyfill";

const EventSource = NativeEventSource || EventSourcePolyfill;

export const REQUEST_UPI_VERIFY_VPA = "REQUEST_UPI_VERIFY_VPA";
export const RECEIVE_UPI_VERIFY_VPA = "RECEIVE_UPI_VERIFY_VPA";
export const RECEIVE_ERROR_UPI_VERIFY_VPA = "RECEIVE_ERROR_UPI_VERIFY_VPA";

export const REQUEST_UPI_MERCHANT_COLLECT_DATA =
  "REQUEST_UPI_MERCHANT_COLLECT_DATA";
export const RECEIVE_UPI_MERCHANT_COLLECT_DATA =
  "RECEIVE_UPI_MERCHANT_COLLECT_DATA";
export const RECEIVE_ERROR_UPI_MERCHANT_COLLECT =
  "RECEIVE_ERROR_UPI_MERCHANT_COLLECT";

export const REQUEST_UPI_TRS_STATUS = "REQUEST_UPI_TRS_STATUS";
export const RECEIVE_UPI_TRS_STATUS = "REQUEST_UPI_TRS_STATUS";
export const RECEIVE_ERROR_UPI_TRS_STATUS = "RECEIVE_ERROR_UPI_TRS_STATUS";

function requestVerifyUpiVPA(uuid, vpa) {
  return { type: REQUEST_UPI_VERIFY_VPA, uuid, vpa };
}

function receiveUpiVerifyResponse(customerName, vpa) {
  return { type: RECEIVE_UPI_VERIFY_VPA, customerName, vpa };
}

function receiveErrorUpiVerifyVpa(errorMsg) {
  return { type: RECEIVE_ERROR_UPI_VERIFY_VPA, errorMsg };
}

function requestUpiMerchantCollectData(uuid, vpa) {
  return { type: REQUEST_UPI_MERCHANT_COLLECT_DATA, uuid, vpa };
}

function receiveUpiMerchantCollectData({ transactionUuid, payapp }) {
  return {
    type: RECEIVE_UPI_MERCHANT_COLLECT_DATA,
    trsUuid: transactionUuid,
    payapp
  };
}

function receiveErrorUpiMerchantCollect(errorMsg) {
  return { type: RECEIVE_ERROR_UPI_MERCHANT_COLLECT, errorMsg };
}

const getCsrfToken = () => {
  const token = document.cookie.match(
    "(^|[^;]+)\\s*XSRF-TOKEN\\s*=\\s*([^;]+)"
  );
  return token ? token.pop() : "";
};

export function fetchVerifyVpaParams(uuid, vpaReq) {
  return dispatch => {
    dispatch(requestVerifyUpiVPA(uuid, vpaReq.vpa));

    return window
      .fetch(`/public/v1/charge/${uuid}/submit/upi/verifyVPA`, {
        method: "POST",
        body: JSON.stringify(vpaReq),
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCsrfToken()
        }
      })
      .then(
        resp => {
          if (resp.status === 400)
            dispatch(receiveErrorUpiVerifyVpa("Invalid VPA"));
          else if (!resp.ok)
            dispatch(receiveErrorUpiVerifyVpa("Could not check VPA"));
          else {
            resp.json().then(json => {
              dispatch(receiveUpiVerifyResponse(json.customerName, vpaReq.vpa));
            });
          }
        },
        () => dispatch(receiveErrorUpiVerifyVpa("Could not reach server"))
      );
  };
}

export function submitUpiMerchantCollectRequest(uuid, form) {
  return dispatch => {
    dispatch(requestUpiMerchantCollectData(uuid, form.vpa));

    return window
      .fetch(`/public/v1/charge/${uuid}/submit/upi/merchantCollect`, {
        method: "POST",
        body: JSON.stringify(form),
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCsrfToken()
        }
      })
      .then(resp => resp.json())
      .then(json => {
        dispatch(receiveUpiMerchantCollectData(json));
        const evtSource = new EventSource(
          `/public/transaction/${json.transactionUuid}/check`
        );
        evtSource.addEventListener("status", () => {
          window.location.assign(`/charge/${uuid}`);
          evtSource.close();
        });
      })
      .catch(error => dispatch(receiveErrorUpiMerchantCollect(error.message)));
  };
}

export function submitSimulateCallback(success, transactionUuid, payapp) {
  const appName = `${payapp === "RBLUPI" ? "rblupi" : "kotakupi"}`;
  const url = `/simulator-in/${appName}/callback/${success ? "ok" : "ko"}`;
  window.fetch(`${url}/${transactionUuid}`, { method: "POST" });
}
